import { render } from "./orderRequest.vue?vue&type=template&id=efc37bd6"
import script from "./orderRequest.vue?vue&type=script&lang=js"
export * from "./orderRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__